
/* @flow */
import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import PickCustomerContainer from '../customer/pick-customer-container';
import WorkDateContainer from '../work-date/work-date-container';
import HsdContainer from '../hsd/hsd-container';
import SpecificationContainer from '../specification/specification-container';
import AmountContainer from '../amount/amount-container';
import { ToggleDisplay } from 'components';

export class WorkDetails extends React.Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
    customer: PropTypes.object,
    registerAssignmentTool: PropTypes.bool.isRequired,
    translationPrefix: PropTypes.string.isRequired
  }

  render () {
    const countryAllowHsd = !this.props.customer ||
      this.props.customer.address.country === 'SWEDEN';
    const workDateClasses = (this.props.user.displayHsd && countryAllowHsd)
      ? 'work-details-col-wrapper work-details-rutrot-margin'
      : 'work-details-col-wrapper';

    return (
      <div className='tool-wrapper'>
        <h2>
          <Translate content={this.props.translationPrefix + 'INVOICE_TOOL'}/>
        </h2>
        <div className='tool-content container'>
          <PickCustomerContainer
            translationPrefix={this.props.translationPrefix}
          />
          <div className='section-padding'>
            <div className='col-sm-12'>
              <h3 className='form-header'><span>2</span> <Translate content='INVOICE_SPEC'/></h3>
            </div>
          </div>
          <div className='workdate-hsd'>
            <div className={workDateClasses}>
              <div className='white-box'>
                <WorkDateContainer
                  registerAssignmentTool={this.props.registerAssignmentTool}
                  translationPrefix={this.props.translationPrefix}
                />
              </div>
            </div>
            <ToggleDisplay show={countryAllowHsd}>
              <ToggleDisplay show={this.props.user.displayHsd}>
                <div className='work-details-col-wrapper col-xs-4'>
                  <div className='white-box'>
                    <HsdContainer
                      translationPrefix={this.props.translationPrefix}
                    />
                  </div>
                </div>
              </ToggleDisplay>
            </ToggleDisplay>
          </div>
          <div className='work-details-col-wrapper col-xs-12'>
            <div className='white-box'>
              <SpecificationContainer
                translationPrefix={this.props.translationPrefix}
              />
            </div>
          </div>
          <AmountContainer />
        </div>
      </div>
    );
  }
}

export default WorkDetails;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/work-details/work-details.js
 **/